import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { Colaborador } from '@/store/catalogos/colaborador';
import { DepartamentoModel } from '@/store/catalogos/departamento';
import { EquipoModel } from '@/store/catalogos/equipo';
import { MarcaModel } from '@/store/catalogos/marcas';
import { UnidadModel } from '@/store/catalogos/unidad';
import { Util } from '@/utils/util';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CatalogoCodigoEquipoService } from '@services/catalogo/catalogoCodigoEquipo.service';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { CatalogoDepartamentoService } from '@services/catalogo/catalogoDepartamento.service';
import { CatalogoMarcaService } from '@services/catalogo/catalogoMarca.service';
import { CatalogoUnidadService } from '@services/catalogo/catalogoUnidad.service';
import { ValidatorsService } from '@services/util/validators.service';
import { map, Observable, startWith } from 'rxjs';
import { FormularioAlcanceComponent } from '../formulario-alcance/formulario-alcance.component';
import { EquipoPatronService } from '@services/catalogo/equipoPatron.service';
import { EquipoService } from '@services/catalogo/equipo.service';
import { FormularioCodigoEquipoCaracteristicaComponent } from '@modules/catalogos/codigo-equipo/formulario-codigo-equipo-caracteristica/formulario-codigo-equipo-caracteristica.component';

@Component({
  selector: 'app-formulario-equipo',
  templateUrl: './formulario-equipo.component.html',
  styleUrls: ['./formulario-equipo.component.scss']
})
export class FormularioEquipoComponent {
  form: FormGroup;
  mostrarBoton: boolean = true;
  mostrarTap: boolean = false;
  title = "Nuevo Equipo";

  codigoEquipoList: CodigoEquipoModel[] = [];
  colaboradorList: Colaborador[] = [];
  departamentoList: DepartamentoModel[] = [];
  marcaList: MarcaModel[] = [];
  unidadList: UnidadModel[] = [];
  realizoList: Colaborador[] = [];

  codigoEquipoControl = new FormControl<string>('', Validators.required);
  filteredCodigoEquipos$: Observable<CodigoEquipoModel[]>;

  realizoControl = new FormControl<string>('', Validators.required);
  filteredRealizo$: Observable<Colaborador[]>;

  colaboradorControl = new FormControl<string>('', Validators.required);
  filteredColaboradores$: Observable<Colaborador[]>;

  departamentoControl = new FormControl<string>('', Validators.required);
  filteredDepartamento$: Observable<DepartamentoModel[]>;

  marcaControl = new FormControl<string>('', Validators.required);
  filteredMarca$: Observable<MarcaModel[]>;

  unidadControl = new FormControl<string>('');
  filteredUnidad$: Observable<MarcaModel[]>;

   diferenciaHoraria = -6;
  constructor(
    private util: Util,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private catalogoService: EquipoPatronService,
    private equipoService:EquipoService,
    private colaboradorService: CatalogoColaboradorService,
    private unidadService: CatalogoUnidadService,
    private codigoEquipoService: CatalogoCodigoEquipoService,
    private departamentoService: CatalogoDepartamentoService,
    private marcaService: CatalogoMarcaService,
    public dialogRef: MatDialogRef<FormularioEquipoComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Equipo";
      this.mostrarTap = true;
      console.log(data);
    }
    if (data.view) {
      this.title = "Vista Equipo";
      this.mostrarTap = true;
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);
    this.codigoEquipoLista();
    this.colaboradorLista();
    this.departamentoLista();
    this.marcaLista();
    this.unidadLista();
    this.realizoLista();

    this.filteredRealizo$ = this.realizoControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    this.filteredColaboradores$ = this.colaboradorControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    this.filteredCodigoEquipos$ = this.codigoEquipoControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCodigoEquipo(value || ''))
    );

    this.filteredDepartamento$ = this.departamentoControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterDepartamento(value || ''))
    );

    this.filteredMarca$ = this.marcaControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterMarca(value || ''))
    );
    if (this.data.update || this.data.view) {
      this.calcularSiguienteCalibracion();

    }

    this.filteredUnidad$ = this.unidadControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterUnidad(value || ''))
    );
    if (this.data.update || this.data.view) {
      this.calcularSiguienteCalibracion();

    }
  }



  calcularSiguienteCalibracion() {
    this.catalogoService.obtenerSiguienteCalibracion(this.data?.row?.idEquipo).subscribe(
      (data) => {
        console.log(data);
        this.form.get('numeroSemana')?.setValue(data.numeroSemana);
        this.form.get('fechaCalibracion')?.setValue(this.datePipe.transform(data.fechaCalibracion, 'dd-MM-yyyy'));;

      });
  }


  unidadLista() {
    this.unidadService.getAll().subscribe(data => {
      this.unidadList = data;
      if (this.data?.row?.unidad?.idUnidad) {
        const unidadSeleccionado = this.unidadList.find(
          (col) => col.idUnidad === this.data?.row?.unidad?.idUnidad
        );
        if (unidadSeleccionado) {
          this.unidadControl.setValue(
            `${unidadSeleccionado.nombreUnidad}`
          );
          this.form.get('idUnidad')?.setValue(unidadSeleccionado.idUnidad);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de unidades.");
    });
  }

  private _filterUnidad(value: any): UnidadModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();
    return this.unidadList.filter(({ nombreUnidad, idUnidad }) => {
      const fullName = `${nombreUnidad}`.toLowerCase();
      const idString = idUnidad.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }

  seleccionarUnidad(event: any) {
    const unidadSeleccionada = event.option.value;
    if (unidadSeleccionada) {
      this.unidadControl.setValue(
        `${unidadSeleccionada.nombreUnidad}`
      );
      this.form.get('idUnidad')?.setValue(unidadSeleccionada.idUnidad);
    }
  }

  abrirAutocompleteUnidad() {
    if (!this.unidadControl.value) {
      this.unidadControl.setValue(' ');
      this.unidadControl.setValue('');
    }
  }

  realizoLista() {
    this.colaboradorService.getAll().subscribe(data => {
      this.realizoList = data;
      if (this.data?.row?.equipo?.realizo?.idColaborador) {
        const realizoSeleccionado = this.colaboradorList.find(
          (col) => col.idColaborador === this.data?.row?.equipo?.realizo?.idColaborador
        );
        if (realizoSeleccionado) {
          this.realizoControl.setValue(
            `${realizoSeleccionado.nombre} ${realizoSeleccionado.apellidoPaterno} ${realizoSeleccionado.apellidoMaterno}`
          );
          this.form.get('realizo')?.setValue(realizoSeleccionado.idColaborador);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de colaboradores.");
    });
  }

  private _filterRealizo(value: any): Colaborador[] {
    const filterValue = (value || '').toString().trim().toLowerCase();

    return this.realizoList.filter(({ nombre, apellidoPaterno, apellidoMaterno, idColaborador }) => {
      const fullName = `${nombre} ${apellidoPaterno} ${apellidoMaterno}`.toLowerCase();
      const idString = idColaborador.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }


  seleccionarRealizo(event: any) {
    const realizoSeleccionado = event.option.value;
    if (realizoSeleccionado) {
      this.realizoControl.setValue(
        `${realizoSeleccionado.nombre} ${realizoSeleccionado.apellidoPaterno} ${realizoSeleccionado.apellidoMaterno}`
      );
      this.form.get('realizo')?.setValue(realizoSeleccionado.idColaborador);
    }
  }

  abrirAutocompleteRealizo() {
    if (!this.realizoControl.value) {
      this.realizoControl.setValue(' ');
      this.realizoControl.setValue('');
    }
  }

  colaboradorLista() {
    this.colaboradorService.getAll().subscribe(data => {
      this.colaboradorList = data;
      if (this.data?.row?.colaborador.idColaborador) {
        const colaboradorSeleccionado = this.colaboradorList.find(
          (col) => col.idColaborador === this.data?.row?.colaborador?.idColaborador
        );
        if (colaboradorSeleccionado) {
          this.colaboradorControl.setValue(
            `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
          );
          this.form.get('idColaborador')?.setValue(colaboradorSeleccionado.idColaborador);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de colaboradores.");
    });
  }

  private _filter(value: any): Colaborador[] {
    const filterValue = (value || '').toString().trim().toLowerCase();

    return this.colaboradorList.filter(({ nombre, apellidoPaterno, apellidoMaterno, idColaborador }) => {
      const fullName = `${nombre} ${apellidoPaterno} ${apellidoMaterno}`.toLowerCase();
      const idString = idColaborador.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }


  seleccionarColaborador(event: any) {
    const colaboradorSeleccionado = event.option.value;
    if (colaboradorSeleccionado) {
      this.colaboradorControl.setValue(
        `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
      );
      this.form.get('idColaborador')?.setValue(colaboradorSeleccionado.idColaborador);
    }
  }

  abrirAutocomplete() {
    if (!this.colaboradorControl.value) {
      this.colaboradorControl.setValue(' ');
      this.colaboradorControl.setValue('');
    }
  }


  codigoEquipoLista() {
    this.codigoEquipoService.getAll().subscribe(data => {
      this.codigoEquipoList = data;

      if (this.data?.row?.equipo.idCodigoEquipo) {
        const codigoEquipoSeleccionado = this.codigoEquipoList.find(
          (col) => col.idCodigoEquipo === this.data?.row?.equipo.idCodigoEquipo
        );
        if (codigoEquipoSeleccionado) {
          this.codigoEquipoControl.setValue(
            `${codigoEquipoSeleccionado.claveEquipo} ${codigoEquipoSeleccionado.nombreEquipo}`
          );
          this.form.get('idCodigoEquipo')?.setValue(codigoEquipoSeleccionado.idCodigoEquipo);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de còdigo de equipos.");
    });
  }

  private _filterCodigoEquipo(value: any): CodigoEquipoModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();

    return this.codigoEquipoList.filter(({ claveEquipo, nombreEquipo, idCodigoEquipo }) => {
      const fullName = `${claveEquipo} ${nombreEquipo}`.toLowerCase();
      const idString = idCodigoEquipo.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }

  seleccionarCodigoEquipo(event: any) {
    const codigoEquipoSeleccionado = event.option.value;
    if (codigoEquipoSeleccionado) {
      this.codigoEquipoControl.setValue(
        `${codigoEquipoSeleccionado.claveEquipo} ${codigoEquipoSeleccionado.nombreEquipo}`
      );
      this.form.get('idCodigoEquipo')?.setValue(codigoEquipoSeleccionado.idCodigoEquipo);
    }
  }

  abrirAutocompleteCodigoEquipo() {
    if (!this.codigoEquipoControl.value) {
      this.codigoEquipoControl.setValue(' ');
      this.codigoEquipoControl.setValue('');
    }
  }

  departamentoLista() {
    this.departamentoService.getAll().subscribe(data => {
      this.departamentoList = data;

      if (this.data?.row?.departamento.idArea) {
        const departamentoSeleccionado = this.departamentoList.find(
          (col) => col.idArea === this.data?.row?.departamento.idArea
        );
        if (departamentoSeleccionado) {
          this.departamentoControl.setValue(
            `${departamentoSeleccionado.nombreArea}`
          );
          this.form.get('idDepartamento')?.setValue(departamentoSeleccionado.idArea);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de departamento.");
    });
  }

  private _filterDepartamento(value: any): DepartamentoModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();

    return this.departamentoList.filter(({ nombreArea, idArea }) => {
      const fullName = `${nombreArea}`.toLowerCase();
      const idString = idArea.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }

  seleccionarDepartamento(event: any) {
    const departamentoSeleccionado = event.option.value;
    if (departamentoSeleccionado) {
      this.departamentoControl.setValue(
        `${departamentoSeleccionado.nombreArea}`
      );
      this.form.get('idDepartamento')?.setValue(departamentoSeleccionado.idArea);
    }
  }

  abrirAutocompleteDepartamento() {
    if (!this.departamentoControl.value) {
      this.departamentoControl.setValue(' ');
      this.departamentoControl.setValue('');
    }
  }

  marcaLista() {
    this.marcaService.getAll().subscribe(data => {
      this.marcaList = data;

      if (this.data?.row?.marca.idMarca) {
        const marcaSeleccionada = this.marcaList.find(
          (col) => col.idMarca === this.data?.row?.marca.idMarca
        );
        if (marcaSeleccionada) {
          this.marcaControl.setValue(
            `${marcaSeleccionada.marca}`
          );
          this.form.get('idMarca')?.setValue(marcaSeleccionada.idMarca);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de marcas.");
    });
  }

  private _filterMarca(value: any): MarcaModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();
    return this.marcaList.filter(({ idMarca, marca }) => {
      const fullName = `${marca}`.toLowerCase();
      const idString = idMarca.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }

  seleccionarMarca(event: any) {
    const marcaSeleccionada = event.option.value;
    if (marcaSeleccionada) {
      this.marcaControl.setValue(
        `${marcaSeleccionada.marca}`
      );
      this.form.get('idMarca')?.setValue(marcaSeleccionada.idMarca);
    }
  }

  abrirAutocompleteMarca() {
    if (!this.marcaControl.value) {
      this.marcaControl.setValue(' ');
      this.marcaControl.setValue('');
    }
  }


  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }

  private buildForm(data: EquipoModel): void {
    this.form = new FormGroup({
      idEquipo: new FormControl(data?.idEquipo ?? ''),
      claveInterna: new FormControl(data?.claveInterna ?? '', {
        nonNullable: true, validators: [Validators.required, Validators.maxLength(10)]
      }),
      idCodigoEquipo: new FormControl(data?.equipo.idCodigoEquipo ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      modelo: new FormControl(data?.modelo ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      serie: new FormControl(data?.serie ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      idDepartamento: new FormControl(data?.departamento.idArea ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      localizacion: new FormControl(data?.localizacion ?? '', {
        nonNullable: true,
        validators: [ Validators.maxLength(70)]
      }),
      idColaborador: new FormControl(data?.colaborador.idColaborador ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      condAlmacenamiento: new FormControl(data?.condAlmacenamiento ?? '', {
        nonNullable: true,
        validators: [Validators.maxLength(250)]
      }),
      ep: new FormControl(data?.ep ?? '', {
        nonNullable: true,
        validators: [Validators.maxLength(10)]
      }),
      fechaAlta: new FormControl(this.ajustarYFormatearFecha(data?.fechaAlta ) ?? '', {
        nonNullable: true
      }),
      fechaBaja: new FormControl(this.ajustarYFormatearFecha(data?.fechaBaja) ?? '', {
        nonNullable: true
      }),
      idMarca: new FormControl(data?.marca.idMarca ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      activo: new FormControl(data?.activo ?? true, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      numeroSemana: new FormControl({ value: 0, disabled: true }, {
        nonNullable: true
      }),
      fechaCalibracion: new FormControl({ value: '', disabled: true }, {
        nonNullable: true
      }),

      //Datos de Calibracion
      tipoVariable: new FormControl(data?.tipoVariable ?? '', {
        nonNullable: true,
        validators: [ Validators.maxLength(20)]
      }),
      idUnidad: new FormControl(data?.unidad?.idUnidad ?? '', {
        nonNullable: true
      }),
      tipCalib: new FormControl(data?.tipCalib ?? '', {
        nonNullable: true,
        validators: [ Validators.maxLength(10)]
      }),
      lugarCalibracion: new FormControl(data?.lugarCalibracion ?? '', {
        nonNullable: true,
        validators: [ Validators.maxLength(70)]
      }),
      interOperacion: new FormControl({ value: data?.interOperacion, disabled: true }, {
        nonNullable: true,
        validators: [ Validators.maxLength(35)]
      }),
      resolucion: new FormControl(data?.resolucion ?? '', {
        nonNullable: true,
        validators: [ Validators.maxLength(35)]
      }),
      exactitud: new FormControl(data?.exactitud ?? '', {
        nonNullable: true,
        validators: [ Validators.maxLength(35)]
      }),
      criterioAceptacion: new FormControl(data?.criterioAceptacion ?? '', {
        nonNullable: true
      }),

      //ANÁLISIS DE MEDICIÓN
      calibFrecuencia: new FormControl(data?.calibFrecuencia ?? 0, {
        nonNullable: true
      }),
      calibApartir: new FormControl(this.ajustarYFormatearFecha(data?.calibApartir) ?? '', {
        nonNullable: true
      }),
      rRLargoFrecuencia: new FormControl(data?.rRLargoFrecuencia ?? 0, {
        nonNullable: true
      }),
      rRLargoApartir: new FormControl(this.ajustarYFormatearFecha(data?.rRLargoApartir) ?? '', {
        nonNullable: true
      }),
      rRCortoFrecuencia: new FormControl(data?.rRCortoFrecuencia ?? 0, {
        nonNullable: true
      }),
      rRCortoApartir: new FormControl(this.ajustarYFormatearFecha(data?.rRCortoApartir) ?? '', {
        nonNullable: true
      }),
      rRVPPFrecuencia: new FormControl(data?.rRVPPFrecuencia ?? 0, {
        nonNullable: true
      }),
      rRVPPApartir: new FormControl(this.ajustarYFormatearFecha(data?.rRVPPApartir) ?? '', {
        nonNullable: true
      }),
      biasFrecuencia: new FormControl(data?.biasFrecuencia ?? 0, {
        nonNullable: true
      }),
      biasApartir: new FormControl(this.ajustarYFormatearFecha(data?.biasApartir) ?? '', {
        nonNullable: true
      }),
      linealidadFrecuencia: new FormControl(data?.linealidadFrecuencia ?? 0, {
        nonNullable: true
      }),
      linealidadApartir: new FormControl(this.ajustarYFormatearFecha(data?.linealidadApartir) ?? '', {
        nonNullable: true
      }),
      estabilidadFrecuencia: new FormControl(data?.estabilidadFrecuencia ?? 0, {
        nonNullable: true
      }),
      estabilidadApartir: new FormControl(this.ajustarYFormatearFecha(data?.estabilidadApartir) ?? '', {
        nonNullable: true
      }),
      atributosFrecuencia: new FormControl(data?.atributosFrecuencia ?? 0, {
        nonNullable: true
      }),
      atributosApartir: new FormControl(this.ajustarYFormatearFecha(data?.atributosApartir) ?? '', {
        nonNullable: true
      }),
      rRGagesFrecuencia: new FormControl(data?.rRGagesFrecuencia ?? 0, {
        nonNullable: true
      }),
      rRGagesApartir: new FormControl(this.ajustarYFormatearFecha(data?.rRGagesApartir) ?? '', {
        nonNullable: true
      }),
      //Método de Calibracion
      claveEquipo: new FormControl(data?.equipo?.claveEquipo ?? '', {
        nonNullable: true,
        validators: [Validators.maxLength(35)]
      }),
      procedimiento: new FormControl(data?.equipo?.procedimiento ?? '', {
        nonNullable: true,
        validators: [Validators.maxLength(35)]
      }),
      realizo: new FormControl(data?.equipo?.realizo?.idColaborador ?? '', {
        nonNullable: true
      }),
      nombre: new FormControl(data?.equipo?.nombreEquipo?? '', {
        nonNullable: true
      }),
      fechaAutorizacion: new FormControl(data?.equipo?.fechaAutorizacion ?? '', {
        nonNullable: true
      }),
    });
    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
      this.colaboradorControl.disable();
      this.codigoEquipoControl.disable(),
        this.departamentoControl.disable();
      this.marcaControl.disable();
    }

  }

  ajustarYFormatearFecha(fecha: Date | string | null): Date | null {
    if (!fecha) {
      return null; 
    }
  
    const fechaObj = new Date(fecha); 
  
    if (isNaN(fechaObj.getTime())) {
      return null; 
    }

    const diferenciaHoraria = 6;
    const fechaAjustada = new Date(fechaObj.getTime() + diferenciaHoraria * 60 * 60 * 1000);
  
    return fechaAjustada; 
  }
  modal() {
    const dialogRef = this.dialog.open(FormularioAlcanceComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true, data: { insert: true, update: false, view: false, row: null }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.success) {

        if (!this.util.isEmpty(result.data.vInicial)) {
          this.form.get('interOperacion')?.setValue(result.data.vInicial + ' - ' + result.data.vFinal);
        } else {
          this.form.get('interOperacion')?.setValue(result.data.numero);
        }

      }
    });
  }

  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const equipo: EquipoModel = this.formToModel();
    const request = this.data.insert
      ? this.equipoService.create(equipo)
       : this.equipoService.update(equipo);
    console.log(equipo);

    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }

private formToModel(): EquipoModel {
  const formValues = this.form.getRawValue();

  const cleanValue = (value: any) => (value === "" || value === undefined ? null : value);

  return {
    idEquipo: cleanValue(formValues.idEquipo),
    claveInterna: cleanValue(formValues.claveInterna),
    equipo: {
      idCodigoEquipo: cleanValue(formValues.idCodigoEquipo),
      claveEquipo: cleanValue(formValues.claveEquipo),
      procedimiento: cleanValue(formValues.procedimiento),
      realizo: {
        idColaborador:cleanValue(formValues.realizo)},
      nombreEquipo:cleanValue(formValues.nombre),
      fechaAutorizacion:cleanValue(formValues.fechaAutorizacion)
    },
    modelo: cleanValue(formValues.modelo),
    serie: cleanValue(formValues.serie),
    departamento: {
      idArea: cleanValue(formValues.idDepartamento)
    },
    localizacion: cleanValue(formValues.localizacion),
    colaborador: {
      idColaborador: cleanValue(formValues.idColaborador)
    },
    condAlmacenamiento: cleanValue(formValues.condAlmacenamiento),
    ep: cleanValue(formValues.ep),
    fechaAlta: cleanValue(formValues.fechaAlta),
    fechaBaja: cleanValue(formValues.fechaBaja),
    marca: {
      idMarca: cleanValue(formValues.idMarca)
    },
    activo: cleanValue(formValues.activo),
    // Datos calibración
    tipoVariable: cleanValue(formValues.tipoVariable),
    unidad: {
      idUnidad: cleanValue(formValues.idUnidad)
    },
    tipCalib: cleanValue(formValues.tipCalib),
    lugarCalibracion: cleanValue(formValues.lugarCalibracion),
    interOperacion: cleanValue(formValues.interOperacion),
    resolucion: cleanValue(formValues.resolucion),
    exactitud: cleanValue(formValues.exactitud),
    criterioAceptacion: cleanValue(formValues.criterioAceptacion),
    // Datos Análisis de Medición
    calibFrecuencia: cleanValue(formValues.calibFrecuencia),
    calibApartir: cleanValue(formValues.calibApartir),
    rRLargoFrecuencia: cleanValue(formValues.rRLargoFrecuencia),
    rRLargoApartir: cleanValue(formValues.rRLargoApartir),
    rRCortoFrecuencia: cleanValue(formValues.rRCortoFrecuencia),
    rRCortoApartir: cleanValue(formValues.rRCortoApartir),
    rRVPPFrecuencia: cleanValue(formValues.rRVPPFrecuencia),
    rRVPPApartir: cleanValue(formValues.rRVPPApartir),
    biasFrecuencia: cleanValue(formValues.biasFrecuencia),
    biasApartir: cleanValue(formValues.biasApartir),
    linealidadFrecuencia: cleanValue(formValues.linealidadFrecuencia),
    linealidadApartir: cleanValue(formValues.linealidadApartir),
    estabilidadFrecuencia: cleanValue(formValues.estabilidadFrecuencia),
    estabilidadApartir: cleanValue(formValues.estabilidadApartir),
    atributosFrecuencia: cleanValue(formValues.atributosFrecuencia),
    atributosApartir: cleanValue(formValues.atributosApartir),
    rRGagesFrecuencia: cleanValue(formValues.rRGagesFrecuencia),
    rRGagesApartir: cleanValue(formValues.rRGagesApartir)
  };
}


 
}
